const Ledger = () => import('@/views/main/report/ledger/Ledger.vue')
export default {
  path: '/main/ledger/records',
  name: 'ledger',
  component: Ledger,
  children: []
}
